import { Shark } from "shark-mvc";

import ManagerBase from "./ManagerBase";

class CustomerManager extends ManagerBase {
	constructor () {
		super("customerManager");
		this.remoteClassName = "customer";
	}
}

const customerManager = new CustomerManager();

Shark.registerController(customerManager);

export default customerManager;
